import { useAuthStore } from '@/stores/auth'

/**
 * 检查是否有指定权限
 * @param {string|string[]} permission - 权限标识
 */
export function hasPermission(permission) {
  const authStore = useAuthStore()
  const permissions = authStore.permissions
  if (!permission) return true
  if (Array.isArray(permission)) {
    return permission.some((p) => permissions.includes(p))
  }
  return permissions.includes(permission)
}

/**
 * 注册 v-permission 指令
 */
export function setupPermissionDirective(app) {
  app.directive('permission', {
    mounted(el, binding) {
      if (!hasPermission(binding.value)) {
        el.parentNode?.removeChild(el)
      }
    },
  })
}
